export default __webpack_public_path__ + "static/media/6.1acc4689.jpg";